var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpArrow = function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M11.992 10.53 6.876 3.477a.463.463 0 0 0-.75 0L1.008 10.53a.116.116 0 0 0 .095.184H2.19a.23.23 0 0 0 .187-.096L6.5 4.937l4.122 5.681c.044.06.113.096.187.096h1.088c.095 0 .15-.107.095-.184"
  })));
};
export default SvgUpArrow;